import React, { Suspense } from 'react';
import Header from './components/Header'
import Footer from './components/Footer'
import { Container } from 'react-bootstrap'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import HomeScreen from './screens/HomeScreen'
import Location from './screens/Location'
// import AboutScreen from './screens/AboutScreen'
// import Hiearchy from './screens/Hiearchy'
// import Products from './screens/Products'
// import Inquiry from './screens/Inquiry';
import Brand_details from './screens/Brand_details'
import Product_lists from './screens/Product_lists'

import Client from './screens/Client'
import { useState } from 'react'

const Products = React.lazy(() => import('./screens/Products'));
const Hiearchy = React.lazy(() => import('./screens/Hiearchy'));
const AboutScreen = React.lazy(() => import('./screens/AboutScreen'));
const Inquiry = React.lazy(() => import('./screens/Inquiry'));

function App() {
  const [isGrayed, setIsGrayed] = useState(false);
  function handleGraying(props){
    if(props===true){
      setIsGrayed(true)
    }
    else{
      setIsGrayed(false)
    }
  }

  return (
    <>
      <Router>
        <Header onGray={handleGraying}/>
        <main className="pb-4 bg-white">
          <div className={isGrayed ? 'backBg active' : 'backBg'}></div>
          <Container>
            <div className="page_content pt-2">
              <Suspense fallback={<p>Loading...</p>}>
                <Switch>
                  <Route path='/' component={HomeScreen} exact/>
                  <Route path='/about/company' component={AboutScreen}/>
                  <Route path='/about/location' component={Location}/>
                  <Route path='/about/hiearchy' component={Hiearchy}/>
                  <Route path="/products" component={Products} exact/>
                  <Route path="/business/client" component={Client}/>
                  <Route path="/products/:id" component={Product_lists} exact/>
                  <Route path="/products/:id/:type" component={Brand_details} />
                  <Route path="/inquiry" component={Inquiry}/>
                </Switch>
              </Suspense>
            </div>
          </Container>
        </main>
        <Footer />
      </Router>
    </>
  );
}

export default App;
